module.exports = __webpack_public_path__ + "static/image/history/pc/202509.ver2_0_2.jpg?712af88a";